export default __webpack_public_path__ + "static/media/male_pink.9be6fd86.svg";